import { GET_WITH_CREDENTIALS, POST_WITH_CREDENTIALS } from '~/api';
import { CsrfTokenUrl, JiraAuthUrl, LogoutUrl } from '~/api/urls';
import { ICsrfToken } from '~/domain/ICsrfToken';
import { APP_DOMAIN } from '~/env';
import { AuthCallbackPageUrl } from '~/pages/urls';

const redirect_uri = `${APP_DOMAIN}${AuthCallbackPageUrl}`;

export const login = async () => {
  const url = JiraAuthUrl.expand({
    redirect_uri,
  });

  // Get the Authorization redirect from the BE, and set the nonce on the server
  const response = await GET_WITH_CREDENTIALS(url) as string;
  window.location.replace(response);
}

export const logout = async() => {
  await POST_WITH_CREDENTIALS(LogoutUrl, {});
};

export const getCsrfToken = async (): Promise<string> => {
  const { token } = await POST_WITH_CREDENTIALS(CsrfTokenUrl, {}) as ICsrfToken;
  return token;
};
